import { useStateValue } from 'providers'

export const Can = ({
  action,
  children,
  subject
}) => {
  const [{ session: { user: { roles } } }] = useStateValue()
  return roles.map(r => r.permissions || []).flat().find((perm) => {
    return perm.subject === subject && perm.action === action
  })
    ? <>{children}</>
    : null
}
